import React from 'react'
import PropTypes from 'prop-types'
import RequestVerifyAction from 'components/Actions/RequestVerify'

const RequestVerifyPage = ({ match }) => (
  <RequestVerifyAction token={match.params.token} />
)

RequestVerifyPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default RequestVerifyPage
